import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TooltipDirectiveService {
  toolValueTop = 0;
  toolValueLeft = 0;

  setstylefunction(
    _renderer: Renderer2,
    _tooltip: unknown,
    _tooltipDelay: number
  ) {
    // tooltipDelay setting
    _renderer.setStyle(
      _tooltip,
      '-webkit-transition',
      `opacity ${_tooltipDelay}ms`
    );

    _renderer.setStyle(
      _tooltip,
      '-moz-transition',
      `opacity ${_tooltipDelay}ms`
    );

    _renderer.setStyle(_tooltip, '-o-transition', `opacity ${_tooltipDelay}ms`);

    _renderer.setStyle(_tooltip, 'transition', `opacity ${_tooltipDelay}ms`);
  }

  createCloseBtnFun(
    closeButton: unknown,
    iconButton: unknown,
    _renderer: Renderer2
  ) {
    _renderer.setAttribute(closeButton, 'aria-label', 'Close Popover');
    _renderer.setAttribute(closeButton, 'type', 'button');
    _renderer.setAttribute(iconButton, 'aria-hidden', 'true');
    _renderer.addClass(closeButton, 'idp-tooltip-close');
    _renderer.addClass(iconButton, 'idp-close-icon');
  }

  getTopLeftValue5(_topLeftPayload: {
    tooltipPosition: string | undefined;
    hostPos: { bottom: number; left: number; width: number };
    tooltipPos: { width: number };
    offset: number;
    tooltip: HTMLElement | null;
    scrollPos: number;
    renderer: Renderer2;
  }) {
    let top: number;
    let left: number;

    if (_topLeftPayload.tooltipPosition === 'bottom-left') {
      top = _topLeftPayload.hostPos.bottom + _topLeftPayload.offset;
      left =
        _topLeftPayload.hostPos.left -
        _topLeftPayload.tooltipPos.width +
        _topLeftPayload.hostPos.width / 2;

      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'top',
        `${top + _topLeftPayload.scrollPos}px`
      );
      _topLeftPayload.renderer.setStyle(
        _topLeftPayload.tooltip,
        'left',
        `${left}px`
      );
    }
  }

  async GetWindowValue() {
    return (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }
}
